/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template "model.velocity"
 */

/**
 * THIS Template MUST remain FRAMEWORK INDEPENDENT!! It is used for Angular, Ionic, Node-Express... any JavaScript framework
 */

/* tslint:disable */
import { DossierClassification } from './dossier-classification.model';
import { DossierStage } from './dossier-stage.model';
import { DossierCapacity } from './dossier-capacity.model';
import { DossierParties } from './dossier-parties.model';
import { Dossier } from './dossier.model';
import { FutureEvolution } from './future-evolution.model';
import { DraftEvolution } from './draft-evolution.model';
import { ReviewEvolution } from './review-evolution.model';
import { ApprovedEvolution } from './approved-evolution.model';
import { RejectedEvolution } from './rejected-evolution.model';
import { Case } from '../case.model';
import { ToBeApprovedEvolution } from './tobe-approved-evolution.model';


export class DossierDetails {
    dossierCode: string; // ecf001
    name?: string; // ecf001
    firstName?: string; // ecf001
    dossierId?: number; // ecf001
    dossierClassification: DossierClassification; // ecf001
    parentDossierCode?: string; // ecf001
    dossierDescriptionCode?: string; // ecf001
    stage?: DossierStage; // ecf001
    courtOfJustice?: string; // ecf001
    openingDate?: string; // ecf001
    lastEvolutionDate?: string; // ecf001
    closingDate?: string; // ecf001
    personCapacities?: DossierCapacity[]; // ecf001
    goodsCapacities?: DossierCapacity[]; // ecf001
    dossierPartiesList?: DossierParties[]; // ecf001
    subDossiers?: Dossier[]; // ecf001
    futureEvolutions?: FutureEvolution[]; // ecf001
    draftEvolutions?: DraftEvolution[]; // ecf001
    reviewEvolutions?: ReviewEvolution[]; // ecf001
    approvedEvolutions?: ApprovedEvolution[]; // ecf001
    toBeApprovedEvolutions?: ToBeApprovedEvolution[]; // ecf001
    rejectedEvolutions?: RejectedEvolution[]; // ecf001
    caseList?: Case[]; // ecf001


    // <editor-fold desc="From and To Json Methods" defaultstate="collapsed">
/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template &quot;model-json.velocity&quot;
 */

    /** ---- Generated part from .\ang-man\src\modules\generator\writers\common\templates\model-json.velocity */

    public static mergeJSON(instance: any, data: any): DossierDetails {
        if (!data) { return instance; }
        if (data.dossierCode != null) {instance.dossierCode = data.dossierCode; }
        if (data.name != null) {instance.name = data.name; }
        if (data.firstName != null) {instance.firstName = data.firstName; }
        if (data.dossierId != null) {instance.dossierId = data.dossierId; }
        if (data.dossierClassification != null) {instance.dossierClassification = data.dossierClassification; }
        if (data.parentDossierCode != null) {instance.parentDossierCode = data.parentDossierCode; }
        if (data.dossierDescriptionCode != null) {instance.dossierDescriptionCode = data.dossierDescriptionCode; }
        if (data.stage != null) {instance.stage = data.stage; }
        if (data.courtOfJustice != null) {instance.courtOfJustice = data.courtOfJustice; }
        if (data.openingDate != null) {instance.openingDate = data.openingDate; }
        if (data.lastEvolutionDate != null) {instance.lastEvolutionDate = data.lastEvolutionDate; }
        if (data.closingDate != null) {instance.closingDate = data.closingDate; }
        if (data.personCapacities != null) {
            instance.personCapacities = [];
            ([].concat(data.personCapacities)).forEach(occurrence => {
                instance.personCapacities.push(new DossierCapacity().fromJSON(occurrence)); // i3
            });
        }
        if (data.goodsCapacities != null) {
            instance.goodsCapacities = [];
            ([].concat(data.goodsCapacities)).forEach(occurrence => {
                instance.goodsCapacities.push(new DossierCapacity().fromJSON(occurrence)); // i3
            });
        }
        if (data.dossierPartiesList != null) {
            instance.dossierPartiesList = [];
            ([].concat(data.dossierPartiesList)).forEach(occurrence => {
                instance.dossierPartiesList.push(new DossierParties().fromJSON(occurrence)); // i3
            });
        }
        if (data.subDossiers != null) {
            instance.subDossiers = [];
            ([].concat(data.subDossiers)).forEach(occurrence => {
                instance.subDossiers.push(new Dossier().fromJSON(occurrence)); // i3
            });
        }
        if (data.futureEvolutions != null) {
            instance.futureEvolutions = [];
            ([].concat(data.futureEvolutions)).forEach(occurrence => {
                instance.futureEvolutions.push(new FutureEvolution().fromJSON(occurrence)); // i3
            });
        }
        if (data.draftEvolutions != null) {
            instance.draftEvolutions = [];
            ([].concat(data.draftEvolutions)).forEach(occurrence => {
                instance.draftEvolutions.push(new DraftEvolution().fromJSON(occurrence)); // i3
            });
        }
        if (data.reviewEvolutions != null) {
            instance.reviewEvolutions = [];
            ([].concat(data.reviewEvolutions)).forEach(occurrence => {
                instance.reviewEvolutions.push(new ReviewEvolution().fromJSON(occurrence)); // i3
            });
        }
        if (data.approvedEvolutions != null) {
            instance.approvedEvolutions = [];
            ([].concat(data.approvedEvolutions)).forEach(occurrence => {
                instance.approvedEvolutions.push(new ApprovedEvolution().fromJSON(occurrence)); // i3
            });
        }
        if (data.toBeApprovedEvolutions != null) {
            instance.toBeApprovedEvolutions = [];
            ([].concat(data.toBeApprovedEvolutions)).forEach(occurrence => {
                instance.toBeApprovedEvolutions.push(new ToBeApprovedEvolution().fromJSON(occurrence)); // i3
            });
        }
        if (data.rejectedEvolutions != null) {
            instance.rejectedEvolutions = [];
            ([].concat(data.rejectedEvolutions)).forEach(occurrence => {
                instance.rejectedEvolutions.push(new RejectedEvolution().fromJSON(occurrence)); // i3
            });
        }
        if (data.caseList != null) {
          instance.castList = [];
          ([].concat(data.caseList)).forEach(occurence => {
            instance.caseList.push(new Case().fromJSON(occurence)); //i3
          })
        }
        return instance; // ir
    }

    public fromJSON(data: any): this { // cbn001
        return DossierDetails.mergeJSON(this, data) as any;
    }

    public static mergeJSONFromObject(target: any, object: DossierDetails) {
        // TODO: mapping
        return object;
    }

    // toJSON ensures that only class-defined fields are exported.
    public toJSON() {
        return DossierDetails.mergeJSONFromObject({}, this);
    }

    // Compares this AppInfo instance with another AppInfo instance, recursively.
    // Transient fields are not considered.
    public equals(other: DossierDetails): boolean {
        return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
    }

    /** ---- */


/** end of template &quot;model-json.velocity&quot; */

    // </editor-fold>

}


/** end of template "model.velocity" */
